import React, { useEffect, useState } from 'react';
import DailyProfitPage from './DailyProfitPage';
import PnLPage from './PnLPage';
import MarginsPage from './MarginsPage';
import ReportsPage from './ReportsPage';
import InsightsPage from './InsightsPage';

const TABS = [
  { key: 'daily', label: 'Daily Profit', Page: DailyProfitPage },
  { key: 'pnl', label: 'P&L', Page: PnLPage },
  { key: 'margins', label: 'Margins & Stock', Page: MarginsPage },
  { key: 'reports', label: 'Reports', Page: ReportsPage },
  { key: 'insights', label: 'Insights', Page: InsightsPage },
];

export default function ProfitHub() {
  const [tab, setTab] = useState(() => {
    try { return localStorage.getItem('icecream_profit_tab') || 'daily'; } catch (e) { return 'daily'; }
  });
  useEffect(() => { try { localStorage.setItem('icecream_profit_tab', tab); } catch (e) { /* ignore */ } }, [tab]);
  const Active = (TABS.find((t) => t.key === tab) || TABS[0]).Page;

  return (
    <div>
      <div className="profit-hub-tabs" role="tablist" style={{
        display: 'flex', gap: 4, padding: 4, margin: '12px 20px 0', borderRadius: 14, background: '#f3eff8',
        overflowX: 'auto', scrollbarWidth: 'none', fontFamily: "'Manrope', system-ui, sans-serif",
      }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            style={{
              flex: '0 0 auto', height: 40, padding: '0 16px', border: 'none', borderRadius: 10, cursor: 'pointer',
              font: 'inherit', fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap',
              background: tab === t.key ? '#fff' : 'transparent',
              color: tab === t.key ? '#231a33' : '#776e86',
              boxShadow: tab === t.key ? '0 1px 4px rgba(35,26,51,0.12)' : 'none',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      <style>{'@media print { .profit-hub-tabs { display: none !important; } }'}</style>
      <Active />
    </div>
  );
}
